import { NotificationName } from 'typings/enums';
import { NotificationItemWorkflow } from 'nomst/Stores/Notification/notificationItemWorkflow';

export class NotificationItemWorkflowSendReview extends NotificationItemWorkflow {
    declare data: INotificationDataWorkFlowSendReview;

    constructor(props: IBaseNotificationItem) {
        super(props);
        this.notificationName = NotificationName.NotificationDataWorkflowSendReview;
    }

    get iconCss(): string {
        return 'icon-paper-plane';
    }

    get contentText(): string {
        return `Sent for review by ${this.data.sentBy}`;
    }

    get employeeName(): string {
        return '';
    }
}